var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.20007 4.19995C5.35806 4.19995 6.30005 3.25796 6.30005 2.09997C6.30005 0.941988 5.35806 0 4.20007 0C3.04209 0 2.1001 0.941988 2.1001 2.09997C2.1001 3.25796 3.04209 4.19995 4.20007 4.19995ZM4.19995 5.25005C2.79596 5.25005 0 5.95204 0 7.35002V8.40001H8.39989V7.35002C8.39989 5.95204 5.60393 5.25005 4.19995 5.25005ZM8.42406 5.28598C9.12005 5.78997 9.60005 6.46196 9.60005 7.34995V8.39994H12V7.34995C12 6.13797 9.90004 5.44797 8.42406 5.28598ZM9.89981 2.10002C9.89981 3.25801 8.95782 4.2 7.79983 4.2C7.47584 4.2 7.17584 4.122 6.89985 3.99C7.27784 3.456 7.49984 2.80201 7.49984 2.10002C7.49984 1.39803 7.27784 0.744039 6.89985 0.210046C7.17584 0.0780472 7.47584 4.8203e-05 7.79983 4.8203e-05C8.95782 4.8203e-05 9.89981 0.942036 9.89981 2.10002Z",
    fill: "#1D1D46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublic);
export default __webpack_public_path__ + "static/media/public.2528dd523a8410c06edb74e128fb2833.svg";
export { ForwardRef as ReactComponent };